import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-how-to-succeed',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule],
  templateUrl: './how-to-succeed.component.html',
  styleUrls: ['./how-to-succeed.component.scss'],
})
export class HowToSucceedComponent {
  activeSection: 'batches' | 'shopping' | 'delivery' = 'batches';
  dialogRef = inject(DynamicDialogRef);
  batchTips = [
    {
      title: 'Check Batch Details',
      description: 'Review order count, total items, and delivery distance before accepting.',
      icon: '📋'
    },
    {
      title: 'Consider Time Constraints',
      description: 'Ensure you have enough time to complete shopping and delivery within the timeframe.',
      icon: '⏰'
    },
    {
      title: 'Check Earnings',
      description: 'Review the batch earnings and ensure they align with your time investment.',
      icon: '💰'
    },
    {
      title: 'Location Familiarity',
      description: 'Accept batches in areas you know well for faster shopping and navigation.',
      icon: '📍'
    }
  ];

  shoppingTips = [
    {
      title: 'Bring Cold Containers',
      description: 'Always carry insulated bags or coolers for frozen and refrigerated items.',
      icon: '🧊'
    },
    {
      title: 'Check Expiration Dates',
      description: 'Select items with the longest expiration dates when possible.',
      icon: '📅'
    },
    {
      title: 'Communicate Substitutions',
      description: 'Contact customers about substitutions before making changes.',
      icon: '📞'
    },
    {
      title: 'Handle Items Carefully',
      description: 'Separate fragile items and avoid crushing bread or produce.',
      icon: '🤲'
    },
    {
      title: 'Follow Shopping Order',
      description: 'Shop non-perishables first, then refrigerated, then frozen items last.',
      icon: '🛒'
    },
    {
      title: 'Double-Check Quantities',
      description: 'Verify item counts and sizes match the order requirements.',
      icon: '✅'
    }
  ];

  deliveryTips = [
    {
      title: 'Maintain Temperature',
      description: 'Keep cold items cold and hot items hot during transport.',
      icon: '🌡️'
    },
    {
      title: 'Secure Items',
      description: 'Prevent items from shifting or falling during transport.',
      icon: '📦'
    },
    {
      title: 'Follow Delivery Instructions',
      description: 'Read and follow any special delivery notes from customers.',
      icon: '📝'
    },
    {
      title: 'Contact Customer',
      description: 'Call or text customers if you encounter any issues during delivery.',
      icon: '📱'
    },
    {
      title: 'Take Photos',
      description: 'Document delivery completion with photos when required.',
      icon: '📸'
    },
    {
      title: 'Be Professional',
      description: 'Maintain a friendly, professional demeanor throughout the delivery.',
      icon: '😊'
    }
  ];

  setActiveSection(section: 'batches' | 'shopping' | 'delivery') {
    this.activeSection = section;
  }

  closeDialog() {
    this.dialogRef.close(true);
  }
} 